import { type MeInformation } from '@api'
import {
  AnalyticsBrowser,
  type EventProperties,
  type SegmentEvent,
} from '@segment/analytics-next'

import { SEGMENT_WRITE_KEY } from './constants'

export const analytics = new AnalyticsBrowser()

if (SEGMENT_WRITE_KEY) {
  analytics.load({
    writeKey: SEGMENT_WRITE_KEY,
  })
  // Initial page call to track referrer information and user activity
  analytics.page()
}

analytics.track = async (
  event: SegmentEvent | string,
  properties?: EventProperties,
) => {
  await analytics.ready()
  if (!analytics.instance) {
    return Promise.reject('Analytics instance is not initialized')
  }
  const teamId = analytics.instance.group().id()

  return analytics.instance.track(event, {
    ...properties,
    teamId,
  })
}

export const onLogout = () => {
  if (!analytics.instance) {
    return
  }
  analytics.instance.reset()
}

export const identify = (userData: MeInformation) => {
  const teamId = String(userData.teamId)
  const userId = String(userData.userId)

  if (!analytics.instance) {
    return
  }
  if (
    !analytics.instance.user().id() ||
    analytics.instance.user().id() !== userId ||
    !analytics.instance.user().traits()?.role
  ) {
    analytics.identify(userId, {
      email: userData.email,
      name: userData.name,
      teamId,
      inTrial: userData.inTrial,
      role: userData.role,
      createdAt: new Date(Date.now() - userData.accountAge),
    })
  }

  if (
    !analytics.instance.group().traits()?.teamId ||
    analytics.instance.group().traits()?.teamId !== teamId
  ) {
    analytics.group(teamId, {
      teamId,
    })
  }
}

export enum SegmentEvents {
  UserSignedIn = 'User Signed In',
  CreatorAdded = 'Creator Added',
  CreatorDeleted = 'Creator Deleted',
  SurveyFilled = 'Survey Filled',
  FeatureUsed = 'Feature Used',
}
